<p on-click("toggleLegal")>
    <str-textual-display textSpans=input.linkTextSpans />
</p>
<ebay-lightbox-dialog open=state.legalOpen on-close('toggleLegal')>
    <iframe class="str-legal-lightbox__iframe" src=input.source />
</ebay-lightbox-dialog>
